import { render, staticRenderFns } from "./ModalSelecionaPessoa.vue?vue&type=template&id=789fe216"
import script from "./ModalSelecionaPessoa.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports